export { default, default as TextAreaInput } from './TextAreaInput'
export * as TextAreaInputStyles from './styles/TextAreaInput.style'

export type { TextAreaInputProps } from './TextAreaInput.types'
export type { StyledTextAreaInputProps } from './styles/TextAreaInput.style.types'
